import Image from 'next/image';

import { blokTestConst } from 'modules/blok-test';
import { IMyResult } from 'modules/mavzuli-test';

import { Visible } from 'components';

interface IProps {
  myResults?: IMyResult;
}

const ResultImage: React.FC<IProps> = ({ myResults }) => (
  <div className="flex justify-center">
    <Visible
      if={myResults?.type === blokTestConst.testTypes.UNIVERSITY_TEST}
      else={
        <Image
          src="/images/happy-result.png"
          alt="happy-result-default"
          width={140}
          height={100}
          loading="lazy"
          className="drop-shadow-[0_2px_50px_rgba(255,255,0,0.4)]"
          title="Yaxshi ball to'plagan foydalanuvchiga ko'rinadigon rasm"
        />
      }
    >
      <Visible
        if={myResults?.ball >= (myResults?.direction?.passing_ball || 0)}
        else={
          <Image
            src="/images/bad-result.png"
            alt="bad-result"
            width={140}
            height={100}
            loading="lazy"
            className="drop-shadow-[0_2px_50px_rgba(255,255,0,0.4)]"
            title="Yaxshi ball to'play olmagan foydalanuvchiga ko'rinadigon rasm"
          />
        }
      >
        <Image
          src="/images/happy-result.png"
          alt="happy-result"
          width={140}
          height={100}
          loading="lazy"
          className="drop-shadow-[0_2px_50px_rgba(255,255,0,0.4)]"
          title="Yaxshi ball to'plagan foydalanuvchiga ko'rinadigon rasm"
        />
      </Visible>
    </Visible>
  </div>
);

export default ResultImage;
